import { Destinatario } from "@modules/viagem/interfaces/ViagemAplicativoMotorista"

export default function determinaSituacao(destinatario: Destinatario){
    const notas = destinatario.notas

    const allVisited = notas.every(nota => nota.situacao !== "Em aberto")
    
    return allVisited ? notas.some(nota => nota.situacao === "Ocorrencia") ? "Ocorrencia" : "Finalizado" : "Não Finalizado"
} 